import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AppConstants, ErrorMessageFormField } from 'src/app/shared/app-constants';
import { environment } from 'src/environments/environment';
import { SessionDataService } from '../../service/session-data.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.css']
,
  standalone: false
})
export class ChangePasswordDialogComponent implements OnInit {
 userForm: FormGroup;
 errorMessageFormField: any =ErrorMessageFormField;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  userName: any;
  constructor(public dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private fb:FormBuilder,
    public spinner: SpinnerService,private sessionDataService: SessionDataService,
  private toaster: ToastrService) {
    this.userName = this.data?.userName;
      this.userForm = this.fb.group({
        password: [''],
        confirmpassword: ['']
  })
     }

  ngOnInit(): void {
    this.userForm = this.fb.group({
    password: ['', [Validators.required, this.passwordValidator()]],
    confirmpassword: ['', [Validators.required, this.passwordValidator()]]
  }, { validators: this.matchPasswordValidator() });
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }
  
  toggleConfirmPassword(){
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  matchPasswordValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const passwordControl = group.get('password');
    const confirmPasswordControl = group.get('confirmpassword');

    const password = passwordControl.value;
    const confirmPassword = confirmPasswordControl.value;

    if (password !== confirmPassword) {
      confirmPasswordControl.setErrors({ passwordMismatch: true });
    } else {
      if (confirmPasswordControl.hasError('passwordMismatch')) {
        confirmPasswordControl.setErrors(null);
      }
    }
    return null;
    };
  }

    passwordValidator(): ValidatorFn {
      return (control: AbstractControl): { [key: string]: boolean } | null => {
        const password = control?.value;
        if (password) {
          const hasUpperCase = /[A-Z]/.test(password);
          const hasLowerCase = /[a-z]/.test(password);
          const hasDigit = /\d/.test(password);
          const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
          const hasMinLength = password.length >= 8;
  
          if (hasUpperCase && hasLowerCase && hasDigit && hasSpecialChar && hasMinLength) {
            return null;
          }
          return { 'passwordStrength': true };
        }
        return null;
      };
    }
  
  
  onClose(){
    this.dialogRef.close();
  }

  changePassword(){
            if (this.userForm.invalid) {
              this.userForm.markAllAsTouched();
              return; 
            }
            let obj = {
            username: this.userName,
            newPassword: this.userForm.get('password').value
            }
             const apiUrl = `${environment.workSpaceAPI}/password/admin/reset` ;
             console.log(apiUrl,obj)
             this.spinner.activate();
             this.sessionDataService.saveUser(apiUrl, obj).subscribe(
               (response) => {
                 if (response && response.success) {
                   this.spinner.deactivate();
                   this.toaster.success('Reset Password Successfully..!');
                   this.dialogRef.close();
                 } else {
                   this.spinner.deactivate();
                   this.toaster.error(
                     response?.message || AppConstants.defaultErrorMessage
                   );
                 }
               },
               (err) => {
                 if (err) {
                   this.spinner.deactivate();
                   this.toaster.error(AppConstants.defaultErrorMessage);
                 }
               }
             );
           }

}
